import React from 'react';
import { BaseIcon } from './BaseIcon';

export const RegularIcon = ({ ...props }) => {
    return <BaseIcon iconType="far" {...props} />;
};

RegularIcon.propTypes = BaseIcon.propTypes;
